import { useState, useEffect } from 'react';
import axios from 'axios';
import { Construction } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const MaintenanceBanner = ({ isAdmin }) => {
  const [mm, setMm] = useState(null);

  useEffect(() => {
    let alive = true;
    const fetchMm = async () => {
      try {
        const r = await axios.get(`${BACKEND_URL}/api/maintenance-mode`, { withCredentials: true });
        if (alive) setMm(r.data);
      } catch { /* silencioso */ }
    };
    fetchMm();
    const id = setInterval(fetchMm, 45000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!mm?.active) return null;

  return (
    <div data-testid="maintenance-banner" className="bg-amber-500 text-amber-950 px-6 py-2.5 flex items-center gap-3 border-b border-amber-600">
      <Construction className="w-5 h-5 shrink-0 animate-pulse" />
      <div className="flex-1 text-sm leading-snug">
        <span className="font-bold uppercase mr-2">Mantenimiento en curso</span>
        <span>{mm.message || 'El sistema está en mantenimiento. Por favor no cargues ni modifiques datos hasta nuevo aviso.'}</span>
        {mm.reason && <span className="opacity-80"> · Motivo: {mm.reason}</span>}
        {mm.until && <span className="opacity-80"> · Vuelve aprox.: {mm.until}</span>}
        {isAdmin && <span className="ml-2 font-medium">(Sos admin: tu acceso sigue completo)</span>}
      </div>
    </div>
  );
};

export default MaintenanceBanner;
